var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { findEpochReportAccount, findImpactNFTMint, findImpactNFTMintAuthority, findLockAccount, findLockTokenAccount, getTokenAccountNullable, ZERO, } from "./util.js";
import { ComputeBudgetProgram, SystemProgram, SYSVAR_CLOCK_PUBKEY, } from "@solana/web3.js";
import * as anchor from "@coral-xyz/anchor";
import { TOKEN_PROGRAM_ID, } from "@solana/spl-token";
import BN from "bn.js";
import { ImpactNftClient } from "@sunrisestake/impact-nft-client";
import { getEpochReportAccount } from "./marinade.js";
var LockClient = /** @class */ (function () {
    function LockClient(config, program, authority) {
        this.config = config;
        this.program = program;
        this.authority = authority;
        this.lockTokenAccount = null;
        this.lockAccount = null;
        this.impactNFTClient = null;
        this.impactNFTDetails = null;
        var lockTokenAccountAddress = findLockTokenAccount(this.config, this.authority)[0];
        this.lockTokenAccountAddress = lockTokenAccountAddress;
        var lockAccountAddress = findLockAccount(config, authority)[0];
        this.lockAccountAddress = lockAccountAddress;
    }
    LockClient.prototype.toLockAccount = function (rawLockAccount) {
        if (!rawLockAccount)
            return null;
        return {
            address: this.lockAccountAddress,
            authority: this.authority,
            lockTokenAccount: rawLockAccount.tokenAccount,
            startEpoch: rawLockAccount.startEpoch,
            updatedToEpoch: rawLockAccount.updatedToEpoch,
            stateAddress: rawLockAccount.stateAddress,
            sunriseYieldAtStart: rawLockAccount.sunriseYieldAtStart,
            yieldAccruedByOwner: rawLockAccount.yieldAccruedByOwner,
        };
    };
    LockClient.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.init()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LockClient.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lockTokenAccountPromise, lockAccountPromise, impactNftClientPromise, _a, lockTokenAccount, lockAccount, impactNFTClient;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        lockTokenAccountPromise = getTokenAccountNullable(this.program.provider.connection, this.lockTokenAccountAddress);
                        lockAccountPromise = this.program.account.lockAccount.fetchNullable(this.lockAccountAddress);
                        impactNftClientPromise = this.config.impactNFTStateAddress
                            ? ImpactNftClient.get(this.program.provider, this.config.impactNFTStateAddress)
                            : Promise.resolve(null);
                        return [4 /*yield*/, Promise.all([
                                lockTokenAccountPromise,
                                lockAccountPromise,
                                impactNftClientPromise,
                            ])];
                    case 1:
                        _a = _b.sent(), lockTokenAccount = _a[0], lockAccount = _a[1], impactNFTClient = _a[2];
                        this.lockTokenAccount = lockTokenAccount;
                        this.lockAccount = this.toLockAccount(lockAccount);
                        this.impactNFTClient = impactNFTClient;
                        this.impactNFTDetails = this.impactNFTClient
                            ? this.impactNFTClient.details()
                            : null;
                        return [2 /*return*/];
                }
            });
        });
    };
    LockClient.build = function (config, program, authority) {
        return __awaiter(this, void 0, void 0, function () {
            var client;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        client = new LockClient(config, program, authority);
                        return [4 /*yield*/, client.init()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, client];
                }
            });
        });
    };
    LockClient.prototype.getLockedBalance = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var lockTokenAccountAddress, tokenAccount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        lockTokenAccountAddress = findLockTokenAccount(this.config, address)[0];
                        return [4 /*yield*/, getTokenAccountNullable(this.program.provider.connection, lockTokenAccountAddress)];
                    case 1:
                        tokenAccount = _a.sent();
                        if (!tokenAccount) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, new BN(tokenAccount.amount.toString(10))];
                }
            });
        });
    };
    LockClient.prototype.getImpactNFTAccounts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var nftMintAuthority, nftMint, impactNftAccounts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.impactNFTClient || !this.config.impactNFTStateAddress)
                            throw new Error("LockClient not initialized or impact nft state disabled");
                        nftMintAuthority = findImpactNFTMintAuthority(this.config)[0];
                        nftMint = findImpactNFTMint(this.config, this.authority)[0];
                        return [4 /*yield*/, this.impactNFTClient.getMintNftAccounts(nftMint, this.authority // holder
                            )];
                    case 1:
                        impactNftAccounts = _a.sent();
                        return [2 /*return*/, {
                                impactNftProgram: impactNftAccounts.program,
                                tokenMetadataProgram: impactNftAccounts.tokenMetadataProgram,
                                impactNftState: this.config.impactNFTStateAddress,
                                nftMint: nftMint,
                                nftMintAuthority: nftMintAuthority,
                                nftTokenAuthority: impactNftAccounts.tokenAuthority,
                                nftMetadata: impactNftAccounts.metadata,
                                nftHolderTokenAccount: impactNftAccounts.userTokenAccount,
                                nftMasterEdition: impactNftAccounts.masterEdition,
                                offsetMetadata: impactNftAccounts.offsetMetadata,
                                offsetTiers: impactNftAccounts.offsetTiers,
                                nftCollectionMint: impactNftAccounts.collectionMint,
                                nftCollectionMetadata: impactNftAccounts.collectionMetadata,
                                nftCollectionMasterEdition: impactNftAccounts.collectionMasterEdition,
                            }];
                }
            });
        });
    };
    LockClient.prototype.lockGSol = function (sourceGSolTokenAccount, impactNFTConfig, lamports) {
        return __awaiter(this, void 0, void 0, function () {
            var epochReportAccount, preInstructions, modifyComputeUnits, initLockAccount, allImpactNFTAccounts, accounts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.impactNFTClient)
                            throw new Error("LockClient not initialized");
                        epochReportAccount = findEpochReportAccount(this.config)[0];
                        preInstructions = [];
                        modifyComputeUnits = ComputeBudgetProgram.setComputeUnitLimit({
                            units: 500000,
                        });
                        preInstructions.push(modifyComputeUnits);
                        if (!!this.lockAccount) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.program.methods
                                .initLockAccount()
                                .accounts({
                                state: this.config.stateAddress,
                                authority: this.authority,
                                gsolMint: this.config.gsolMint,
                                lockAccount: this.lockAccountAddress,
                                lockGsolAccount: this.lockTokenAccountAddress,
                                systemProgram: SystemProgram.programId,
                                rent: anchor.web3.SYSVAR_RENT_PUBKEY,
                            })
                                .instruction()];
                    case 1:
                        initLockAccount = _a.sent();
                        preInstructions.push(initLockAccount);
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.getImpactNFTAccounts()];
                    case 3:
                        allImpactNFTAccounts = _a.sent();
                        accounts = __assign({ state: this.config.stateAddress, gsolMint: this.config.gsolMint, authority: this.authority, sourceGsolAccount: sourceGSolTokenAccount, lockGsolAccount: this.lockTokenAccountAddress, lockAccount: this.lockAccountAddress, epochReportAccount: epochReportAccount, systemProgram: SystemProgram.programId, tokenProgram: TOKEN_PROGRAM_ID, rent: anchor.web3.SYSVAR_RENT_PUBKEY, clock: SYSVAR_CLOCK_PUBKEY }, allImpactNFTAccounts);
                        return [2 /*return*/, this.program.methods
                                .lockGsol(lamports)
                                .accounts(accounts)
                                .preInstructions(preInstructions)
                                .transaction()];
                }
            });
        });
    };
    /**
     * Returns the current level of the user's impact NFT
     * if they have one.
     */
    LockClient.prototype.getCurrentLevel = function () {
        if (!this.lockAccount)
            return null; // no lock account yet
        if (!this.impactNFTClient || !this.impactNFTDetails)
            throw new Error("LockClient not initialized");
        return this.impactNFTClient.getLevelForOffset(this.lockAccount.yieldAccruedByOwner);
    };
    // Return the amount of yield that needs to be accrued (in lamports) to reach the next level
    // Or null if the user is already at the max level, or if impact nfts are disabled
    LockClient.prototype.getYieldToNextLevel = function (currentLevel) {
        if (!this.impactNFTClient || !this.impactNFTDetails)
            return null; // impact nfts are disabled
        if (!this.lockAccount)
            return this.impactNFTDetails.levels[0].offset; // should be 0 for the first level
        return this.impactNFTClient.getAmountToNextOffset(this.lockAccount.yieldAccruedByOwner, currentLevel);
    };
    LockClient.prototype.updateLockAccount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var epochReportAccount, modifyComputeUnits, allImpactNFTAccounts, offset, newCollectionMint, newCollectionMetadata, newCollectionMasterEdition, updateAccounts, accounts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.impactNFTClient)
                            throw new Error("LockClient not initialized");
                        epochReportAccount = findEpochReportAccount(this.config)[0];
                        modifyComputeUnits = ComputeBudgetProgram.setComputeUnitLimit({
                            units: 300000,
                        });
                        return [4 /*yield*/, this.getImpactNFTAccounts()];
                    case 1:
                        allImpactNFTAccounts = _a.sent();
                        return [4 /*yield*/, this.calculateUpdatedYieldAccrued()];
                    case 2:
                        offset = _a.sent();
                        return [4 /*yield*/, this.getUpdateCollectionForOffset(new BN(offset))];
                    case 3:
                        newCollectionMint = _a.sent();
                        newCollectionMetadata = this.impactNFTClient.getMetadataAddress(newCollectionMint);
                        newCollectionMasterEdition = this.impactNFTClient.getMasterEditionAddress(newCollectionMint);
                        return [4 /*yield*/, this.impactNFTClient.getUpdateNftAccounts(allImpactNFTAccounts.nftMint, new BN(offset))];
                    case 4:
                        updateAccounts = _a.sent();
                        accounts = {
                            state: this.config.stateAddress,
                            gsolMint: this.config.gsolMint,
                            authority: this.authority,
                            lockGsolAccount: this.lockTokenAccountAddress,
                            lockAccount: this.lockAccountAddress,
                            epochReportAccount: epochReportAccount,
                            impactNftProgram: allImpactNFTAccounts.impactNftProgram,
                            impactNftState: allImpactNFTAccounts.impactNftState,
                            tokenProgram: TOKEN_PROGRAM_ID,
                            tokenMetadataProgram: allImpactNFTAccounts.tokenMetadataProgram,
                            // FIXME(redundant): Remove from here and the impactNft program.
                            // It's neither used nor checked in the updateNFT instruction.
                            nftTokenAccount: allImpactNFTAccounts.nftHolderTokenAccount,
                            nftMint: allImpactNFTAccounts.nftMint,
                            nftMintAuthority: allImpactNFTAccounts.nftMintAuthority,
                            nftTokenAuthority: allImpactNFTAccounts.nftTokenAuthority,
                            nftMetadata: allImpactNFTAccounts.nftMetadata,
                            offsetMetadata: allImpactNFTAccounts.offsetMetadata,
                            offsetTiers: allImpactNFTAccounts.offsetTiers,
                            nftCollectionMint: updateAccounts.collectionMint,
                            nftCollectionMetadata: updateAccounts.collectionMetadata,
                            nftCollectionMasterEdition: updateAccounts.collectionMasterEdition,
                            // nftNewCollectionMint: updateAccounts.newCollectionMint,
                            // nftNewCollectionMetadata: updateAccounts.newCollectionMetadata,
                            // nftNewCollectionMasterEdition: updateAccounts.newCollectionMasterEdition,
                            nftNewCollectionMint: newCollectionMint,
                            nftNewCollectionMetadata: newCollectionMetadata,
                            nftNewCollectionMasterEdition: newCollectionMasterEdition,
                        };
                        return [2 /*return*/, this.program.methods
                                .updateLockAccount()
                                .accounts(accounts)
                                .preInstructions([modifyComputeUnits])
                                .transaction()];
                }
            });
        });
    };
    LockClient.prototype.unlockGSol = function (targetGSolTokenAccount) {
        return __awaiter(this, void 0, void 0, function () {
            var epochReportAccount, accounts;
            return __generator(this, function (_a) {
                epochReportAccount = findEpochReportAccount(this.config)[0];
                accounts = {
                    state: this.config.stateAddress,
                    gsolMint: this.config.gsolMint,
                    authority: this.authority,
                    targetGsolAccount: targetGSolTokenAccount,
                    lockGsolAccount: this.lockTokenAccountAddress,
                    lockAccount: this.lockAccountAddress,
                    epochReportAccount: epochReportAccount,
                    systemProgram: SystemProgram.programId,
                    tokenProgram: TOKEN_PROGRAM_ID,
                    rent: anchor.web3.SYSVAR_RENT_PUBKEY,
                    clock: SYSVAR_CLOCK_PUBKEY,
                };
                return [2 /*return*/, this.program.methods.unlockGsol().accounts(accounts).transaction()];
            });
        });
    };
    LockClient.prototype.getUpdateCollectionForOffset = function (offset) {
        return __awaiter(this, void 0, void 0, function () {
            var level;
            return __generator(this, function (_a) {
                if (!this.impactNFTClient)
                    throw new Error("LockClient not initialized");
                level = this.impactNFTClient.getLevelForOffset(offset);
                // This can only happen if the lowest level has an offset > 0,
                // which in our case, is invalid (you get an NFT at level 0 as soon as you lock, at which point your
                // offset is 0)
                if (!level) {
                    throw new Error("No level found for offset ".concat(offset.toString()));
                }
                return [2 /*return*/, level.collectionMint];
            });
        });
    };
    /**
     * Given a lock account, calculate the amount of yield accrued since the last update.
     */
    LockClient.prototype.calculateUpdatedYieldAccrued = function () {
        return __awaiter(this, void 0, void 0, function () {
            var epochReportAccount, globalYieldAccruedSinceLastUpdate, yieldAccruedWithUnstakeFee, userLockedGsol, userYieldAccrued;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.lockAccount)
                            throw new Error("User has no lock account");
                        if (!this.lockTokenAccount)
                            throw new Error("User has no lock token account");
                        return [4 /*yield*/, getEpochReportAccount(this.config, this.program).then(function (res) { return res.account; })];
                    case 1:
                        epochReportAccount = _a.sent();
                        if (epochReportAccount === null)
                            throw new Error("Epoch report account does not exist");
                        globalYieldAccruedSinceLastUpdate = epochReportAccount.extractableYield
                            .add(epochReportAccount.extractedYield)
                            .sub(this.lockAccount.sunriseYieldAtStart);
                        yieldAccruedWithUnstakeFee = globalYieldAccruedSinceLastUpdate
                            .muln(997)
                            .divn(1000);
                        userLockedGsol = new BN(this.lockTokenAccount.amount.toString());
                        userYieldAccrued = epochReportAccount.currentGsolSupply.eq(ZERO)
                            ? ZERO
                            : yieldAccruedWithUnstakeFee
                                .mul(userLockedGsol)
                                .div(epochReportAccount.currentGsolSupply);
                        return [2 /*return*/, this.lockAccount.yieldAccruedByOwner.add(userYieldAccrued)];
                }
            });
        });
    };
    return LockClient;
}());
export { LockClient };
//# sourceMappingURL=../../src/dist/lock.js.map